import * as Sentry from "@sentry/react";

export function initSentry() {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,

    // Performance Monitoring
    tracesSampleRate: 1.0,

    // Session Replay: disabled
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,

    integrations: [
      Sentry.browserTracingIntegration(),
    ],
  });
}
